import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment';
import { ActivatedRoute } from '@angular/router';
import { IvrListItemModel, IvrModel } from '../ivr.model';
import { IvrService } from '../ivr.service';
import { NotificationService } from '../../shared/notification.service';
import { TranslateService } from '@ngx-translate/core';
import { AmplitudeService } from '../../shared/services/amplitude.service';
import { ConfirmDialogComponent } from '../../shared/dialog/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material';
import { Subscription } from '../../shared/models/plans';

@Component({
  selector: 'cc-ivr-list',
  templateUrl: './ivr-list.component.html',
  styleUrls: ['./ivr-list.component.scss']
})
export class IvrListComponent implements OnInit {
  public displayedColumns: string[] = ['name', 'author', 'dates', 'phoneNumbers', 'workingHours', 'actions'];
  public dataSource: IvrModel[];
  // @Input() subscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    private ivrService: IvrService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    private translate: TranslateService,
    private amplitudeService: AmplitudeService
  ) {}

  ngOnInit() {
    this.translate.get(['IVR.PHONE_NUMBERS', 'IVR.PHONE_NUMBER']).subscribe((res: any) => {
      this.dataSource = this.mapIvrsToTableDataSource(this.route.snapshot.data['ivrs'], res);
    });
    // console.log(this.subscription.licenses[0].planName);
  }

  deleteIvr(ivrId: number) {
    this.amplitudeService.logEvent('Panel:Ivr:List: Delete modal opened');
    this.dialog
      .open(ConfirmDialogComponent, {
        data: {
          title: 'IVR.CONFIRM_DELETE_IVR',
          body: 'IVR.CONFIRM_DELETE_IVR_INFO'
        }
      })
      .afterClosed()
      .subscribe(confirm => {
        if (confirm) {
          this.amplitudeService.logEvent('Panel:Ivr:List: Delete confirmed');
          this.ivrService.removeIvr(`${ivrId}`).subscribe(() => {
            this.ivrService.getIvrs().subscribe(ivrs => {
              this.translate.get(['IVR.PHONE_NUMBERS', 'IVR.PHONE_NUMBER']).subscribe((res: any) => {
                this.dataSource = this.mapIvrsToTableDataSource(ivrs, res);
                this.notificationService.open('IVR.SUCCESS_REMOVE_IVR');
              });
            });
          });
        } else {
          this.amplitudeService.logEvent('Panel:Ivr:List: Delete cancelled');
        }
      });
  }

  mapNumberToDay(dayOfTheWeek: number) {
    return moment()
      .day(dayOfTheWeek)
      .format('ddd');
  }

  formatTime(time) {
    return moment(time, 'HH:mm:ss').format('HH:mm');
  }

  sortDays(days) {
    return days.sort();
  }

  mapIvrsToTableDataSource(ivrs, translations) {
    return ivrs.map((ivr: IvrListItemModel) => ({
      id: ivr.id,
      name: ivr.name,
      author: ivr.createdBy.username,
      dates: `${moment(ivr.createdAt).format('YYYY-MM-DD')} / ${moment(ivr.updatedAt).format('YYYY-MM-DD')}`,
      phoneNumbers: `${ivr.assignedMsisdns.length} ${
        ivr.assignedMsisdns.length === 1 ? translations['IVR.PHONE_NUMBER'] : translations['IVR.PHONE_NUMBERS']
      }`,
      workingHours: ivr.workingHours
    }));
  }
}
